import React, { useState, useEffect, SyntheticEvent } from "react";
import { Link, useHistory } from "react-router-dom";
import assets from "../admin/crudFunctions/assets";

const Welcome = () => {
  const history: any = useHistory();
  const [phone, setPhone] = useState<string>("");
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");

  const fetchClient = async (phone: string): Promise<any> => {
    // url endpoint to serverless function
    const endpoint = `getData?endpoint=client/${phone}`;
    const url = assets.serverlessUrl + endpoint;

    try {
      const response = await fetch(url);
      if (response.status >= 200 && response.status <= 299) {
        setError(false);
        setMessage("");
        return response.json();
      } else if (response.status === 404) {
        setError(true);
        setMessage("No existe cliente con ese número de teléfono");
      } else {
        setError(true);
        setMessage("Ha ocurrido un error, intenta de nuevo");
      }
    } catch (error) {
      console.log(error);
      setError(true);
      setMessage("Ha ocurrido un error, intenta de nuevo");
    }
  };

  const handleSubmit = async (e: SyntheticEvent): Promise<void> => {
    e.preventDefault();
    if (phone) {
      setLoading(true);
      const client: Promise<any> = await fetchClient(phone);
      setLoading(false);
      if (client) {
        history.push({
          pathname: "/confirm",
          state: { client: client },
        });
      }
    } else {
      setError(true);
      setMessage("Ingresa un número de teléfono");
    }
  };

  useEffect(() => {
    fetch(assets.apiUrl + "client/wake/").then(() => setLoading(false));
  }, []);

  return (
    <React.Fragment>
      <div className="container grid justify-items-center md:mx-auto">
        <div className="flex">
          <Link to="/tecnico/login">
            <button
              type="button"
              className="bg-viper mt-7 mr-1 rounded-lg h-10 w-32 text-center text-2xl text-white"
            >
              Técnicos
            </button>
          </Link>
          <Link to="/admin/login">
            <button
              type="button"
              className="bg-viper mt-7 ml-1 rounded-lg h-10 w-32 text-center text-2xl text-white"
            >
              Admin
            </button>
          </Link>
        </div>
        {/* <img
          src='logo.png'
          alt='Vipernet Logo'
          className='w-1/3 mt-5 mb-3 md:w-1/5'
        /> */}
        <h1 className="mt-8 text-5xl font-bold">INTRASAT SA</h1>
        <h1 className="mt-8 text-5xl font-bold">BIENVENIDO</h1>
        <h2 className="mt-5 mb-5 text-2xl text-center w-10/12 leading-6">
          Ingresa el número de teléfono asociado al titular de tu servicio de
          internet
        </h2>
        <p className="mt-5 mb-5 text-base text-left md:text-center w-10/12">
          Sin guiones, paréntesis, espacios, ni comas. Ejemplo: 04247732776
        </p>
        {error && (
          <h2 className="text-2xl text-center w-10/12 text-red-500">
            {message}
          </h2>
        )}
        {loading ? (
          <div className="loader animate-spin mt-5"></div>
        ) : (
          <form className="grid" onSubmit={handleSubmit}>
            <input
              type="text"
              value={phone}
              name="phone"
              id="phone"
              placeholder="04241234567"
              className="border-solid border-2 border-black rounded-full h-14 w-80 text-center text-xl mb-28"
              onChange={(e) => setPhone(e.target.value.replace(/\D/, ""))}
            />

            <button
              type="submit"
              className="bg-black active:bg-gray-800 rounded-full h-14 w-80 text-center text-white text-3xl"
            >
              Siguiente
            </button>
          </form>
        )}
      </div>
    </React.Fragment>
  );
};

export default Welcome;
